import styled from 'styled-components';
import { StyledAdminListHeaders } from '../../AdminListHeaderCell/styles/StyledAdminListHeaders';

export const StyledAdminEquipmentGroupsListHeader = styled.div`
  ${StyledAdminListHeaders}

  .admin-list-header-cell-container {
    &.link {
      flex-grow: 0;
      flex-basis: initial;
      width: 7.2rem;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
